export default {
    props: {
        feed: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            current: null
        }
    },
    methods: {
        checked(item) {
            return this.current && item.id === this.current.id
        },
        toggle(item) {
            if(this.checked(item)) {
                this.current = null;
                this.$emit('clear');
                return;
            }
            this.current = item;
            this.$emit('selected', item);
        },
        itemClass(item) {
            return {
                ['is-active']: this.checked(item)
            };
        }
    }
};